"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/js/typography/fontWeights.ts
var fontWeights = {
  regular: "400",
  medium: "500",
  bold: "700"
};



exports.fontWeights = fontWeights;
//# sourceMappingURL=chunk-Y6UTFJGN.js.map